"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = greenGradient;
function greenGradient() {
  return "\n    background: linear-gradient(-134deg, #1fcc64 0%, #45775e 100%);\n  ";
}